import React, { useState } from "react";
// 1. IMPORT LINK from react-router-dom
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";
import LogoImage from "../images/k-bakery-logo.jpeg";
import { bakeryAddress } from "../config/business";

const Footer = () => {
  const [email, setEmail] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Assuming you handle the signup logic elsewhere, keeping it for context
    const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/signup/temp`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const result = await res.json();
    alert(result.message);
  };

  return (
    <footer className="relative bg-gradient-to-r from-blue-50 via-pink-50 to-purple-50 py-12  overflow-hidden">
      {/* Floating Background Blobs */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-pink-200 opacity-30 rounded-full blur-3xl blob-animation"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-200 opacity-40 rounded-full blur-3xl blob-animation"></div>

      {/* Main Footer Content */}
      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 px-6 text-gray-700">
        
        {/* Logo & Description */}
        <div>
          <img
            src={LogoImage}
            alt="K Bakery Logo"
            className="w-28 md:w-32 h-auto mb-3 float-animation"
          />
          <p className="text-gray-600 text-sm leading-relaxed">
            K Bakery – Every slice tells a story. Classic flavors, playful fusions, and happiness in every bite.
          </p>
        </div>

        {/* Quick Links - UPDATED TO USE <Link> */}
        <div>
          <h4 className="font-semibold text-lg text-pink-700 mb-3">Quick Links</h4>
          <ul className="space-y-2 text-gray-700 text-sm">
            <li><Link to="/" className="hover:text-pink-500 transition">Home</Link></li>
            <li><Link to="/menu" className="hover:text-pink-500 transition">Menu</Link></li>
            <li><Link to="/about" className="hover:text-pink-500 transition">About</Link></li>
            <li><Link to="/contact" className="hover:text-pink-500 transition">Contact</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-pink-500 transition">Privacy Policy</Link></li>
            <li><Link to="/termsconditions" className="hover:text-pink-500 transition">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Specialties - UPDATED TO USE <Link> */}
        <div>
          <h4 className="font-semibold text-lg text-pink-700 mb-3">Our Specialties</h4>
          <ul className="space-y-2 text-gray-700 text-sm">
            <li><Link to="/menu/cakes" className="hover:text-pink-500 transition">Eggless Cakes</Link></li>
            <li><Link to="/menu/brownies" className="hover:text-pink-500 transition">Brownies</Link></li>
            <li><Link to="/menu/cupcakes" className="hover:text-pink-500 transition">Cupcakes</Link></li>
            <li><Link to="/menu/bentocakes" className="hover:text-pink-500 transition">Custom Desserts</Link></li>
          </ul>
        </div>

        {/* Contact & Social (External/Non-Route Links use <a>) */}
        <div>
          <h4 className="font-semibold text-lg text-pink-700 mb-3">Connect With Us</h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li>Email: <a href="mailto:kbakery1002@gmail.com" className="hover:text-pink-500 transition">kbakery1002@gmail.com</a></li>
            <li>Phone: <a href="tel:+1403-360-3664" className="hover:text-pink-500 transition">+1 403-360-3664</a></li>
            <li>Address: {bakeryAddress}</li>
          </ul>
          <div className="flex space-x-4 mt-4 text-gray-600 text-lg">
            <a
              href="https://www.facebook.com/share/1WhzupUs4s/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              className="hover:text-pink-500 transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/kbakerryy?igsh=MWxkaWczd3c3NGZpYw%3D%3D&utm_source=qr"
              target="_blank"
              rel="noreferrer"
              className="hover:text-pink-500 transition"
            >
              <FaInstagram />
            </a>
            <a href="mailto:kbakery1002@gmail.com" className="hover:text-pink-500 transition">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative text-center text-sm text-gray-500 mt-10">
        © {new Date().getFullYear()} K Bakery. All rights reserved.
      </div>

      {/* Floating Animation Styles */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .float-animation {
          animation: float 6s ease-in-out infinite;
        }
        @keyframes blob {
          0%, 100% { transform: scale(1); border-radius: 40% 60% 70% 30% / 40% 40% 60% 60%; }
          50% { transform: scale(1.1); border-radius: 70% 30% 40% 60% / 50% 60% 40% 50%; }
        }
        .blob-animation {
          animation: blob 15s ease-in-out infinite;
        }
      `}</style>
    </footer>
  );
};

export default Footer;